module.exports = __webpack_public_path__ + "img/封禁.56381453.png";